var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriggerHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23281_93784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68548 0.60022C7.58303 0.60022 6.60753 1.15737 5.99951 2.01029C5.39818 1.15737 4.42267 0.60022 3.31354 0.60022C1.48281 0.60022 -0.000488281 2.12722 -0.000488281 4.01189C-0.000488281 6.88017 5.99951 11.5093 5.99951 11.5093C5.99951 11.5093 11.9995 6.88017 11.9995 4.01189C11.9995 2.12722 10.5162 0.60022 8.68548 0.60022Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23281_93784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerHeart);
export default __webpack_public_path__ + "static/media/triggerHeart.6bb83f42.svg";
export { ForwardRef as ReactComponent };